export default function printBuildInfo() {
  /* eslint-disable no-console */
  console.log('<----BUILD INFO---->');
  console.log(`env: ${env || 'local'}`);
  if (FEbuild) console.log(`FEbuild: ${FEbuild}`);
  if (commitHash) console.log(`commitHash: ${commitHash}`);
  console.log(`buildTimestamp: ${CIbuildTimeStamp}`);
  console.log('<------------------>');
  /* eslint-enable no-console */
}
